// extracted by mini-css-extract-plugin
export default {"dotGroup":"StepsWidgetDotGroup_dotGroup__ep1SV","dot":"StepsWidgetDotGroup_dot__4OU31","dotLine":"StepsWidgetDotGroup_dotLine__P5jdB","active":"StepsWidgetDotGroup_active__OwXfh"};